export default "__VITE_ASSET__CqUn$GSq__"